import { Eye as Eye_kojaro } from './Eye.kojaro';
import { Eye as Eye_phosphor } from './Eye.phosphor';
import { Eye as Eye_zoomg } from './Eye.zoomg';
import { Eye as Eye_zoomit } from './Eye.zoomit';

const IconRenderer = () => {
  switch (process.env.NEXT_PUBLIC_ICON_SYSTEM) {
    case 'kojaro':
      return Eye_kojaro;

    case 'zoomg':
      return Eye_zoomg;

    case 'phosphor':
      return Eye_phosphor;

    default:
      return Eye_zoomit;
  }
};

export const Eye = IconRenderer();
